import React from 'react';
import { graphql, navigate } from 'gatsby';
import GenericError from '../components/ShoppingCart/GenericError';
import {
  chatWithWhatsAppHandle,
  flattenNodes,
  getErrorMessage,
  isEkycError
} from '../helpers/common';
import { ERROR_CODES } from '../types/common.types';
import { useSelector, useDispatch } from 'react-redux';
import { navigation } from '../middlewares/navigation-constants';
import { getUrlParams } from '@lux/helpers';
import useTranslate from '../hooks/useTranslation';
import { ACTION_TYPES as SHOP_ACTION_TYPES } from '../constants/actions';

export const Error = ({ data }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { ekycState } = useSelector(state => ({ ekycState: state.ekyc }));
  const allErrorMessagesFlattened = flattenNodes(data.allErrorMessage);
  const genericErrorMessage = getErrorMessage(
    ERROR_CODES.GENERIC,
    allErrorMessagesFlattened
  );

  if (!genericErrorMessage) return null;

  const urlParams = getUrlParams();
  const errorProps = isEkycError(ekycState, urlParams)
    ? {
        title: t('EKYC_ERROR_TITLE'),
        errorText: t('EKYC_ERROR_MESSAGE'),
        primaryButtonText: t('BACK_TO_HOME_CTA_TEXT'),
        secondaryButtonText: t('CHAT_WITH_US'),
        onPrimaryClick: () => {
          dispatch({ type: SHOP_ACTION_TYPES.PAYMENT.CLEAR_BUY_FLOW_DATA });
          dispatch({ type: 'CLEAR_CHECKOUT_ERROR' });
          navigate(`/${navigation.MAIN_PLANS_PAGE}`, { replace: true });
        },
        onSecondaryClick: chatWithWhatsAppHandle
      }
    : {
        title: genericErrorMessage.title,
        errorText: genericErrorMessage.description,
        primaryButtonText: genericErrorMessage.ctaText,
        onPrimaryClick: () =>
          window.location.replace(genericErrorMessage.ctaURL),
        footerList: genericErrorMessage.footerLinks
      };

  return <GenericError {...errorProps} />;
};

export const query = graphql`
  query ErrorQuery {
    allErrorMessage {
      edges {
        node {
          ...AemComponentsFragment
        }
      }
    }
  }
`;

export default Error;
